<template>
	<div
		class="modal mandatory-modal"
		:class="{ 'mandatory-modal--dark': darkTheme }"
		@click="close"
	>
		<div class="modal-holder" @click.stop>
			<span class="modal-title">
				Orders Update Required
			</span>
			<span class="mandatory-modal-caption">
				Your order must include
			</span>
			<span class="mandatory-modal-condition">
				{{ condition }}
			</span>
			<template>
				<div class="modal-buttons">
					<div class="button" @click="toMenu">
						Menu
					</div>
					<div class="button" @click="close">
						Ok
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
export default {
	name: 'MandatoryOrderRequirementsModal',

	props: {
		condition: {
			type: String,
			default: 'at least 1 food item'
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		close() {
			this.$emit('close')
		},

		toMenu() {
			this.close()
			this.$router.push({
				name: 'products'
			})
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.mandatory-modal {
	display: flex;
	align-items: center;
	justify-content: center;

	.modal-holder {
		display: block;
		padding-bottom: 0;

		.modal-title {
			padding-bottom: 0;
			margin-bottom: 18px;
		}

		.mandatory-modal-caption {
			display: block;
			color: rgba(#1d1b25, 0.5);
			font-weight: 600;
			padding-bottom: 0;
			margin-bottom: 8px;
		}

		.mandatory-modal-condition {
			display: block;
			padding-bottom: 0;
			margin-bottom: 20px;
			color: $white;
			font-size: 20px;
		}

		.modal-buttons {
			display: flex;
			justify-content: space-between;
			margin: 0 -20px 0 -20px;

			.button {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: calc(50% - 1px);
				border-radius: 0 0 10px 0;
				padding: 10px;
				height: 48px;

				&:first-child {
					border-radius: 0 0 0 10px;
				}
			}
		}
	}

	&--dark {
		.modal-holder {
			background-color: $dark-blue;

			.modal-title,
			.modal-content,
			.mandatory-modal-caption {
				color: $white;
			}
		}
	}
}
</style>
